import { TTextAlign, TVerticalAlign, TWidgetSize } from 'context/StudioEditorProvider';

const BASE_CANVAS = {
  width: 360,
  height: 800,
};

export const FRAME_RENDER_WIDTH = BASE_CANVAS.width;

export const FRAME_RENDER_HEIGHT = BASE_CANVAS.height;

export const SAFE_ZONE_INSET = { top: 0.06, bottom: 0.05 };

export const TEXT_ALIGNS: TTextAlign[] = ['left', 'center', 'right'];

export const VERTICAL_ALIGNS: TVerticalAlign[] = ['top', 'center', 'bottom'];

export const FONT_SIZE_RANGE = {
  min: 8,
  max: 96,
};

/** Base-canvas px, like `FONT_SIZE_RANGE` — an emoji's size is its `style.fontSize`. */
export const EMOJI_SIZE_RANGE = {
  min: 32,
  max: 320,
};

export const POLL_SIZE_PRESETS: Record<
  TWidgetSize,
  { font: number; width: number; height: number }
> = {
  small: { font: 12, width: 60, height: 17 },
  medium: { font: 14, width: 76, height: 21 },
  large: { font: 17, width: 88, height: 26 },
};
